import { render, staticRenderFns } from "./BlueShadow3.vue?vue&type=template&id=2f9c3b68&scoped=true&lang=pug"
import script from "./BlueShadow3.vue?vue&type=script&lang=js"
export * from "./BlueShadow3.vue?vue&type=script&lang=js"
import style0 from "./BlueShadow3.vue?vue&type=style&index=0&id=2f9c3b68&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c3b68",
  null
  
)

export default component.exports